import React from 'react';
import { AimOutlined } from '@ant-design/icons';
import { ResumeFix } from '../../../types';
import { getCategoryLabel, getPriorityLabel, getPriorityMeta } from './reviewDisplay';
import css from './FixCard.module.scss';

interface FixCardProps {
  fix: ResumeFix;
}

const FixCard: React.FC<FixCardProps> = ({ fix }) => {
  const isAgeSignal = fix.category === 'age_signals';
  const priorityClass = css[`priority_${fix.priority}`] ?? '';
  const meta = getPriorityMeta(fix.priority);
  const tagClass = css[`tag_${meta.tone}`] ?? '';

  return (
    <div
      className={`${css.card} ${priorityClass} ${isAgeSignal ? css.ageSignal : ''}`}
    >
      <div className={css.header}>
        <span className={css.categoryWrap}>
          {isAgeSignal && (
            <AimOutlined
              className={css.missionIcon}
              aria-label="Age-bias signal — our core focus"
            />
          )}
          <span className={css.category}>{getCategoryLabel(fix.category)}</span>
        </span>
        <span className={`${css.tag} ${tagClass}`} aria-label={getPriorityLabel(fix.priority)}>
          <span className={css.tagSymbol} aria-hidden="true">
            {meta.symbol}
          </span>
          {meta.short}
        </span>
      </div>
      <p className={css.issue}>{fix.issue}</p>
      <p className={css.why}>{fix.whyItMatters}</p>
      <p className={css.suggestion}>{fix.suggestion}</p>
    </div>
  );
};

export default FixCard;
